// test1802
(1802 && 0);
